import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";
import { getStorage } from 'firebase/storage';
import { loadStripe } from "@stripe/stripe-js";

const firebaseConfig = {
  apiKey: "AIzaSyBXje6vfK6ozjsSPn2_JdUU3Z_N6VnbBGM",
  authDomain: "nantahala-mountain-resor-596d9.firebaseapp.com",
  projectId: "nantahala-mountain-resor-596d9",
  storageBucket: "nantahala-mountain-resor-596d9.firebasestorage.app",
  messagingSenderId: "44364961786",
  appId: "1:44364961786:web:5c7b801600c54f32487643"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const functions = getFunctions(app, "us-central1");
const db = getFirestore(app, "nmrdb");
const storage = getStorage(app);

// Connect to emulator for local testing
if (process.env.NODE_ENV === "development") {
  connectFunctionsEmulator(functions, "localhost", 5001);
  console.log("Connected to Functions emulator at localhost:5001");
}

// Force token refresh on auth state change and wait for initialization
let authInitialized = false;
onAuthStateChanged(auth, async (user) => {
  if (user) {
    try {
      const token = await user.getIdToken(true);
      console.log('Global token refresh on auth state change:', token);
      authInitialized = true;
    } catch (error) {
      console.error('Error refreshing token on auth state change:', error);
    }
  } else {
    authInitialized = true;
  }
});

// Utility to wait for auth initialization
const waitForAuth = async () => {
  while (!authInitialized) {
    console.log('Waiting for auth initialization...');
    await new Promise(resolve => setTimeout(resolve, 500));
  }
  console.log('Auth initialization complete');
};

export { auth, db, functions, storage, waitForAuth, signInWithEmailAndPassword, signOut, httpsCallable };
export const stripePromise = loadStripe("pk_live_51RJGbQ2LLD5b85JhsoIEo8MTi4zITnXgJvqSiBmWyWr8w000kXFvCo6WBn2sflUGRYbvIkH4HyLxDUuekislaGlA00nf2Ls5AY"); 